import { useEffect } from "react";
import { Modal as AntModal } from "antd";

const BackButtonWarning = ({ warning = "Are you sure you want to go back?" }) => {
    useEffect(() => {
        const handleBackButton = async () => {
            const confirmLeave = await new Promise((resolve) => {
                AntModal.confirm({
                    title: "Confirm Navigation",
                    content: warning,
                    okText: "Yes",
                    cancelText: "No",
                    onOk: () => resolve(true),
                    onCancel: () => resolve(false),
                });
            });

            if (!confirmLeave) {
                window.history.pushState(null, "", window.location.pathname);
            }
        };

        window.history.pushState(null, "", window.location.pathname);
        window.addEventListener("popstate", handleBackButton);

        return () => {
            window.removeEventListener("popstate", handleBackButton);
        };
    }, [warning]);

    return null;
};

export default BackButtonWarning;
